$('body').on('click', '#button_pr', function () {

  if ($('#check_pr').is(':checked')) {
    $(this).submit();
  }
  $("#privacy_error_pr").addClass("ms_hide_element");
  if (!$('#check_pr').is(':checked')) {
    $("#privacy_error_pr").removeClass("ms_hide_element");
    $("#privacy_error_pr").fadeIn(500);
    $("#privacy_error_pr").fadeOut(4000);
    return false;
  }
})

// $('body').on( "click", "#checkout", async function(e) {
//   e.preventDefault();

  
//   $(".ajax-cart__error--messages").removeClass("mini-cart__cart-note").html("")
//   const { items } = await WAU.ThemeCart.getCart();
//   const skuList = items.map((item) => item.sku)
  
//   const response = await fetch('https://api.viceroy-erp.maktagg.com/check-stock',{
//     method:'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({
//       products: skuList
//     })
//   });
//   if(response.ok) {
//     const body = await response.json()
//     const skuNoStock = body.filter(item => !item.hasStock).map(item => item.sku);
//     if(skuNoStock.length > 0) {

//       const productNames = items.filter(item => skuNoStock.includes(item.sku)).map(item => item.title)
//       const message = `<span>Los siguientes articulos ya no tienen stock:
//         <p>${productNames.join('\n')}</p>
//       </span>`;

//       $(".ajax-cart__error--messages").addClass("mini-cart__cart-note").html(message)
//       return false;
//     }
    
//   }
//   return true;
// })